type Stages = Record<string, Record<string, any>>

export function getStageAndScreenByStep(stages: Stages, currentStep: number) {
  let step = 1
  for (const [stageKey, screens] of Object.entries(stages)) {
    const uniqueScreenNumbers = Array.from(
      new Set(
        Object.keys(screens)
          .filter(key => /^screen_\d+/.test(key) && screens[key] != null)
          .map(key => key.match(/^screen_(\d+)/)?.[1])
          .filter(Boolean)
      )
    )
    for (const screenNumber of uniqueScreenNumbers) {
      if (step === currentStep) {
        return {
          stage: Number(stageKey.match(/\d+/)?.[0]),
          screen: Number(screenNumber),
        }
      }
      step++
    }
  }
  return {
    stage: 0,
    screen: 0
  }
}
